/*jshint esversion: 6 */
import React, { Component } from 'react';
import '../css/style.css';
import OnlyText from "./OnlyText.js";

class Gmap extends Component {
  constructor(props){
    super(props);
    this.displayGmap = this.displayGmap.bind(this);
    this.getSourceObject = this.getSourceObject.bind(this);
  }

  displayGmap(){
    var gmapUrl = this.props.gmapUrl;
    var keyi = this.props.keyi;
    var templateObj = this.props.templateObj;
    const rows = [];
        rows.push(
            <div key={"gmap"+keyi}  className="gmap_container">
                <div className="gmap">
                    <div className="gmap_source"  dangerouslySetInnerHTML={gmapUrl} >
                    </div>
                </div>
            </div>
        );
    return rows;
  }

 getSourceObject(gmapstring){
     var strArr = gmapstring.split(' ');
     let srcObj = strArr.filter(attr => (attr.indexOf('src') >= 0) );
     let srcValue = "";
     if(srcObj){
        console.log('srcObj', srcObj);
        if(srcObj.length){
            let sArr = srcObj[0].split('"');
            console.log('sArr', sArr);
            if(sArr){
                if(sArr.length >= 2){
                    srcValue = sArr[1];
                    console.log('srcValue', srcValue);
                }
            }
        }
     }
     console.log(srcValue);
     return srcValue;
 }

    render() {
        //console.log('Manus props', this.props);
        const gRows = this.displayGmap();
        var content = this.props.content;
        var header = this.props.header;
        var h = this.props.height;
        var w = this.props.width;
        var gmapUrl = this.getSourceObject(this.props.gmapUrl);
        return (
          <div className="manus_container" >
                <OnlyText
                  header = {header}
                  content={content}
                />
           
            <div>    
                <Iframe src={gmapUrl} height={h} width={w}/>  
            </div>
          </div>
        );
      }

}

export default Gmap;

function  Iframe(props){     
    return(         
      <div>      
          <iframe src={props.src} height={props.height} width={props.width}/>        
      </div>
    )
}


// WEBPACK FOOTER //
// ./src/Templates/Gmap.js